import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  BalanceQuery,
  BalanceService,
  config,
  ErrorStateService,
  MemberQuery,
  Partner,
  PartnerQuery,
  PointsTransferService,
  RenewalResponse,
} from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Subscription } from 'rxjs';
import { Regex } from 'src/app/shared/utilities/regex';

@Component({
  selector: 'fgb-partner-bonus-transfer',
  templateUrl: './partner-bonus-transfer.component.html',
  styleUrls: ['./partner-bonus-transfer.component.scss'],
})
export class PartnerBonusTransferComponent implements OnInit {
  transferCreaditForm: FormGroup;
  partnerSub: Subscription;
  partners: Partner[] = [];
  selectedPartner: Partner | undefined;
  transferStatus: boolean = false;
  submitted: boolean = false;
  @ViewChild('successTransfer', { static: true }) successModalRef: ElementRef;
  @ViewChild('failedTransfer', { static: true }) failedModalRef: ElementRef;
  currentBalance: number;
  isLoading: boolean = false;
  minTransfer = 1;

  constructor(
    private memberQuery: MemberQuery,
    private pointTransferService: PointsTransferService,
    private partnerQuery: PartnerQuery,
    private balanceQuery: BalanceQuery,
    private modalService: NgbModal,
    private errorService: ErrorStateService,
    private balanceService: BalanceService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.transferCreaditForm = this.fb.group({
      memberId: ['', [Validators.required]],
      amount: [0, [Validators.required, Validators.pattern(Regex.currency)]],
    });
    this.balanceQuery
      .selectPurse(config.purseConfig.combined)
      .subscribe((bal) => {
        this.currentBalance = bal ?? 0;
      })
      .unsubscribe();

    this.partnerSub = this.partnerQuery.selectAll().subscribe((partners) => {
      if (partners.length > 0) {
        this.partners = partners;
        this.transferCreaditForm.get('memberId')?.setValue(partners[0].MemberId);
        this.transferCreaditForm.get('amount')?.setValue(0);
      }
    });
  }

  get f() {
    return this.transferCreaditForm.controls;
  }

  get targetMemberEmail(): string | undefined {
    const targetMember = this.partners.find((partner) => partner.MemberId === this.f.memberId.value);
    return targetMember?.Email;
  }

  // call to transfer bonus credit to given Member ID
  transferBonusCredit(bonusAmount: number) {
    this.submitted = true;
    this.isLoading = true;
    let sourceMember = this.memberQuery.getUserContext();
    let targetMemberId = this.f.memberId.value;
    let amountInPence = Math.round(bonusAmount * 100);
    firstValueFrom(this.pointTransferService.transferBalance(sourceMember.memberId, targetMemberId, amountInPence))
      .then((response) => {
        let transferResponse = response as RenewalResponse;
        if (!!transferResponse.ErrorNumber) {
          this.errorService.addError(transferResponse.ErrorDescription);
          this.transferStatus = false;
          this.openTransferStatusModal();
        } else if (!!transferResponse.Tickets.filter((ticket) => !!ticket.ErrorNumber).length) {
          this.errorService.addError(transferResponse.Tickets.filter((ticket) => !!ticket.ErrorNumber)[0].ErrorDesc);
          this.transferStatus = false;
          this.openTransferStatusModal();
        } else {
          this.transferStatus = true;
          this.openTransferStatusModal();
          this.balanceService.debitBalance(config.purseConfig.combined, bonusAmount);
        }
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
        this.transferStatus = false;
        this.openTransferStatusModal();
      });
  }

  openTransferStatusModal() {
    if (this.transferStatus) {
      this.modalService.open(this.successModalRef, { centered: true });
    } else {
      this.modalService.open(this.failedModalRef, { centered: true });
    }
  }

  dismissModal() {
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    if (this.partnerSub) {
      this.partnerSub.unsubscribe();
    }
  }
}
